<template>
  <div>
    <LoginModal
      v-if="currentModal === 'login'"
      @close="closeModal"
      @show-register="showModal('register')"
      @show-forgot-password="showModal('forgot-password')"
    />
    
    <RegisterModal
      v-if="currentModal === 'register'"
      @close="closeModal"
      @show-login="showModal('login')"
    />
    
    <ForgotPasswordModal
      v-if="currentModal === 'forgot-password'"
      @close="closeModal"
      @show-login="showModal('login')"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import LoginModal from './LoginModal.vue'
import RegisterModal from './RegisterModal.vue'
import ForgotPasswordModal from './ForgotPasswordModal.vue'

export default {
  name: 'AuthManager',
  components: {
    LoginModal,
    RegisterModal,
    ForgotPasswordModal
  },
  computed: {
    ...mapState(['showAuthModal', 'authModalType']),
    currentModal() {
      return this.showAuthModal ? (this.authModalType || 'login') : null
    }
  },
  mounted() {
    // The backdrop no longer closes these modals (a stray click outside must
    // not discard a part-typed email/password), so Escape is the keyboard way
    // out, alongside the X button.
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    ...mapMutations(['setShowAuthModal', 'setAuthModalType']),

    onKeydown(e) {
      if (e.key === 'Escape' && this.currentModal) this.closeModal()
    },
    
    showModal(type) {
      this.setAuthModalType(type)
      this.setShowAuthModal(true)
    },
    
    closeModal() {
      this.setShowAuthModal(false)
      // Reset to login after a delay
      setTimeout(() => {
        this.setAuthModalType('login')
      }, 300)
      // Drop the invitation context so a future "Sign in" click from
      // the navbar doesn't accidentally inherit a stale banner / email
      // prefill from an earlier invitation flow.
      this.$store.commit('setInvitationContext', null)
    }
  }
}
</script>